import { Box, Typography, Chip, alpha, useTheme } from '@mui/material';
import { Monitor, Smartphone, Tablet } from 'lucide-react';

const DEVICE_ICONS = {
  desktop: <Monitor size={20} />,
  mobile: <Smartphone size={20} />,
  tablet: <Tablet size={20} />,
};

const UserDevicesTab = ({ devices }) => {
  const theme = useTheme();

  if (!devices?.length) {
    return <Typography variant="body2" sx={{ color: theme.palette.text.secondary, py: 3 }}>No devices recorded.</Typography>;
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
      {devices.map((d, i) => (
        <Box key={d.id || i} sx={{
          p: 2, borderRadius: '12px', flex: '1 1 220px', maxWidth: 300,
          border: `1px solid ${theme.palette.divider}`,
          bgcolor: theme.palette.background.paper,
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
            <Box sx={{
              p: 1, borderRadius: '8px',
              bgcolor: alpha(theme.palette.primary.main, 0.1),
              color: theme.palette.primary.main,
              display: 'flex',
            }}>
              {DEVICE_ICONS[d.device_type] || <Monitor size={20} />}
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
                {d.name || d.device_type || 'Unknown'}
              </Typography>
              <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                {d.device_type || 'unknown'}
              </Typography>
            </Box>
            <Chip
              label={d.is_active ? 'Active' : 'Inactive'}
              size="small"
              sx={{
                fontSize: '0.65rem', fontWeight: 600,
                bgcolor: d.is_active ? alpha('#4caf50', 0.12) : alpha('#f44336', 0.12),
                color: d.is_active ? '#4caf50' : '#f44336',
              }}
            />
          </Box>
          <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }}>
            IP: {d.ip_address || '—'}
          </Typography>
          <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }}>
            Last active: {d.last_active ? new Date(d.last_active).toLocaleString() : '—'}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default UserDevicesTab;
